export default __webpack_public_path__ + "static/media/materialize-6.cad252ba.jpg";